import './TournamentStanding.css'
import React, { useEffect, useState, useCallback, memo } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { useGetStageQuery } from '../../redux/stageService/stageApiSlice'
import { assignAlphabeticalNames } from '../../generalExternalFunctions'
import RoundRobinGrid from '../RoundRobinGrid/RoundRobinGrid'
import OlympicPlusGrid from '../OlympicPlusGrid/OlimpicPlusGrid'
import { Match } from '../Match/Match'

const TournamentStandingComponent = ({ menuTab, stageNumber, auth, match }) => {
	const { t } = useTranslation()
	const matchIsActive = sessionStorage.getItem('activatedComponent')
	const { tournamentUid } = useParams()
	const tournamentState = useSelector(state => state.tournament.tournament) // Получаем состояние турнира

	const { data: stageData = {}, error, isLoading, refetch } = useGetStageQuery({
		tournament_uid: tournamentUid,
		stageNumber: stageNumber
	}) // Stage data

	const [stage, setStage] = useState({})
	const [matchIsOpened, setMathIsOpened] = useState(matchIsActive ? true : false)
	const [matchData, setMatchData] = useState({})

	useEffect(() => {
		if (Object.keys(stageData).length !== 0) {
			const stageWithNamedGroups = assignAlphabeticalNames(stageData)
			setStage(stageWithNamedGroups)
		}
	}, [stageData, stageNumber, tournamentState])

	useEffect(() => {
		refetch()
	}, [refetch, stageNumber, tournamentState, menuTab])

	const sendMatchData = useCallback((matchData) => {
		setMatchData(matchData)
		setMathIsOpened(true)
		match(true)
	}, [match])

	const closeMatch = useCallback(() => {
		setMathIsOpened(false)
		match(false)
	}, [match])

	if (isLoading) { return <h1>Loading</h1> }
	if (error) { console.log(error) }

	return (
		<>
			<div className="standing-container">
				<div className="standing-wrapper">
					{
						!matchIsOpened ?
							stage?.levels?.map((level, levelIndex) => {
								return (
									<React.Fragment key={levelIndex}>
										{
											stage?.levels?.length > 1 &&
											<p className="standing-header">
												{t('Level') + ' ' + (levelIndex + 1)}
											</p>
										}

										{
											level?.groups?.map((grp, index) =>
												<div key={index}>
													{
														grp?.type === 'round_robin' ?
															<RoundRobinGrid
																group={grp}
																groupIndex={index}
																tournamentState={tournamentState}
																sendMatchData={sendMatchData}
																levelIndex={levelIndex}
																auth={auth}
															/>
															:
															<OlympicPlusGrid
																group={grp}
																groupIndex={index}
																tournamentState={tournamentState}
																sendMatchData={sendMatchData}
																levelIndex={levelIndex}
																auth={auth}
															/>
													}
												</div>
											)
										}
									</React.Fragment>
								)
							})
							:
							
							<Match match={matchData} closeMatch={closeMatch} />
					}
				</div>
			</div>
		</>
	)
}

export const TournamentStanding = memo(TournamentStandingComponent)